export function isValidRegex(str) {
  try {
    new RegExp(str);
    return true;
  } catch (e) {
    return false;
  }
}

export function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}

// Ein Replacement ist keine Regex. Geprüft wird nur, ob es Capture Groups
// referenziert, die das zugehörige Search-Pattern nicht definiert.
function replacementError(pattern, replacement) {
  if (!replacement || !isValidRegex(pattern)) return "";
  const groupCount = new RegExp(`${pattern || ""}|`).exec("").length - 1;
  const groupNames = new Set(
    [...(pattern || "").matchAll(/\(\?<([A-Za-z_$][\w$]*)>/g)].map(
      ([, name]) => name,
    ),
  );
  const unknownNumber = [...replacement.matchAll(/\$(\d{1,2})/g)].some(
    ([, number]) => Number(number) > groupCount,
  );
  const unknownName = [...replacement.matchAll(/\$<([^>]*)>/g)].some(
    ([, name]) => !groupNames.has(name),
  );
  return unknownNumber || unknownName ? "Unknown capture group" : "";
}

// Die Regeln laufen im Backend mit Python `regex`. Dort sind globale
// Inline-Flags wie `(?i)` am Anfang gültig, in JavaScript nicht.
function backendPattern(pattern) {
  return (pattern || "").replace(/^\(\?[aiLmsux]+\)/, "");
}

export function anonymizationFieldError(key, form) {
  if (key.endsWith("search"))
    return isValidRegex(backendPattern(form[key])) ? "" : "Invalid regex";
  return replacementError(
    backendPattern(form[key.replace("replace", "search")]),
    form[key],
  );
}
